import React from 'react';

import { guiTypes } from './actions'
import { STEP_START } from '../../constants'
import { getStepOrder } from '../../../app/constants'


const initialState = {
    currentStep: STEP_START,
    currency: null,
    signingModals: {

    },
    showStoppers: {

    },
    showStopperType: {

    },
}


export function gui(state = initialState, action) {

    switch(action.type) {
        
        case guiTypes.SET_STEP:
            return {
                ...state,
                currentStep: action.step
            };
        case guiTypes.NEXT_STEP:
            return {
                ...state,
                currentStep: getStepOrder(action.offerQueryParams)[getStepOrder(action.offerQueryParams).indexOf(state.currentStep) + 1]
            };
        case guiTypes.PREV_STEP:
            let STEP_ORDER = getStepOrder(action.offerQueryParams);
            return {
                ...state,
                currentStep: (STEP_ORDER.indexOf(state.currentStep) - 1 < 0)
                    ? STEP_ORDER[0]
                    : STEP_ORDER[STEP_ORDER.indexOf(state.currentStep) - 1]
            };
        case guiTypes.SET_CURRENCY:
            return {
                ...state,
                currency: action.value
            };            
        case guiTypes.OPEN_MODAL:
            return {
                ...state,
                signingModals: {
                    ...state.signingModals,
                    [action.id]: true
                }
            };
        case guiTypes.CLOSE_MODAL:
            return {
                ...state,
                signingModals: {
                    ...state.signingModals,
                    [action.id]: false
                }
            };            

        case guiTypes.SET_ACTIVE_CUSTOMER_ID:
            return {
                ...state,
                signing: {
                    ...state.signing,
                    activeCustomerId: action.customerId
                }
            };            
        case guiTypes.SET_ACTIVE_CONTRACT_TYPE:
            return {
                ...state,
                signing: {
                    ...state.signing,
                    activeContractType: action.contractType
                }
            };
        case guiTypes.SHOW_STOPPER:
            return {
                    ...state,
                    showStoppers: {
                        ...state.showStoppers,
                        [action.showStopperCustomerId]: (action.isShowStopper === 'true')
                    },
                    showStopper: Object.values({
                        ...state.showStoppers,
                        [action.showStopperCustomerId]: (action.isShowStopper === 'true')
                    }).some(element => element === true),
                    showStopperType: {
                        ...state.showStopperType,
                        [action.showStopperCustomerId]: action.showStopperType
                    }
                };
    
        default:
            return state
    }
}